import Notification from '@kyvg/vue3-notification'
import { App } from 'vue'
import { notifyInjectionKey } from '@/keys'

export default (app: App) => {
    app.use(Notification)

    app.provide(notifyInjectionKey, app.config.globalProperties.$notify)
}
